// A recurring task/event has ONE colour for the whole series (Jade, 2026-10-16):
// editing the colour from any block recolours every block. Older builds saved a
// colour edited from one block as that occurrence's override only, so this also
// drops the `color` from every override of the item, so none keeps an old one.
// Time / end time / done / sub-task overrides are left exactly as they were.
export function withoutOccurrenceColors(overrides, itemId) {
  const prefix = `${itemId}:`;
  let changed = false;
  const next = {};
  for (const [k, v] of Object.entries(overrides || {})) {
    if (k.startsWith(prefix) && v && "color" in v) {
      const { color, ...rest } = v; // eslint-disable-line no-unused-vars
      next[k] = rest;
      changed = true;
    } else next[k] = v;
  }
  return changed ? next : overrides;
}
